import { OfficialRole } from "../officials/entity";
export var EventPlanningRole;
(function (EventPlanningRole) {
    EventPlanningRole[EventPlanningRole["Organizer"] = 0] = "Organizer";
    EventPlanningRole[EventPlanningRole["Secretary"] = 1] = "Secretary";
    EventPlanningRole[EventPlanningRole["SportVicepresident"] = 2] = "SportVicepresident";
    EventPlanningRole[EventPlanningRole["ForeignAdjudicatorApprover"] = 3] = "ForeignAdjudicatorApprover";
    EventPlanningRole[EventPlanningRole["CompetitionLead"] = 4] = "CompetitionLead";
    EventPlanningRole[EventPlanningRole["LeadScrutineer"] = 5] = "LeadScrutineer";
    EventPlanningRole[EventPlanningRole["Scrutineer"] = 6] = "Scrutineer";
    EventPlanningRole[EventPlanningRole["CompetitionCommissioner"] = 7] = "CompetitionCommissioner";
    EventPlanningRole[EventPlanningRole["EventInSameRegion"] = 8] = "EventInSameRegion";
})(EventPlanningRole || (EventPlanningRole = {}));
export var eventPlanningRoles = [
    EventPlanningRole.Organizer,
    EventPlanningRole.Secretary,
    EventPlanningRole.SportVicepresident,
    EventPlanningRole.ForeignAdjudicatorApprover,
    EventPlanningRole.CompetitionLead,
    EventPlanningRole.LeadScrutineer,
    EventPlanningRole.Scrutineer,
    EventPlanningRole.CompetitionCommissioner,
    EventPlanningRole.EventInSameRegion,
];
export var getEventPlanningRoleName = function (val) {
    if (val === EventPlanningRole.Organizer) {
        return "Organizátor";
    }
    if (val === EventPlanningRole.Secretary) {
        return "Sekretariát";
    }
    if (val === EventPlanningRole.SportVicepresident) {
        return "Vedoucí oblasti sportu";
    }
    if (val === EventPlanningRole.ForeignAdjudicatorApprover) {
        return "Schvalovatel zahraničních porotců";
    }
    if (val === EventPlanningRole.CompetitionLead) {
        return "Vedoucí soutěže";
    }
    if (val === EventPlanningRole.LeadScrutineer) {
        return "Hlavní sčitatel";
    }
    if (val === EventPlanningRole.Scrutineer) {
        return "Sčitatel";
    }
    if (val === EventPlanningRole.CompetitionCommissioner) {
        return "Soutěžní komisař";
    }
    if (val === EventPlanningRole.EventInSameRegion) {
        return "Akce v regionu";
    }
    return "";
};
var RegistrationState;
(function (RegistrationState) {
    RegistrationState[RegistrationState["Excused"] = 0] = "Excused";
    RegistrationState[RegistrationState["Registered"] = 1] = "Registered";
    RegistrationState[RegistrationState["NoShow"] = 2] = "NoShow";
    RegistrationState[RegistrationState["InitialClassRequired"] = 101] = "InitialClassRequired";
})(RegistrationState || (RegistrationState = {}));
var EventOfficialDefaults = {
    id: 0,
    eventId: 0,
    dayOfEvent: 1,
};
var CompetitionDefaults = {
    id: 0,
    eventId: 0,
    dayOfEvent: 1,
    dances: [],
};
var StartType;
(function (StartType) {
    StartType[StartType["Unknown"] = 0] = "Unknown";
    StartType[StartType["MustStart"] = 1] = "MustStart";
    StartType[StartType["CanStartUpToLimit"] = 2] = "CanStartUpToLimit";
    StartType[StartType["OverLimit"] = 3] = "OverLimit";
})(StartType || (StartType = {}));
var CompetitorType;
(function (CompetitorType) {
    CompetitorType[CompetitorType["Couple"] = 1] = "Couple";
    CompetitorType[CompetitorType["SoloDancer"] = 2] = "SoloDancer";
    CompetitorType[CompetitorType["Duo"] = 3] = "Duo";
    CompetitorType[CompetitorType["Group"] = 4] = "Group";
    CompetitorType[CompetitorType["ProAm"] = 5] = "ProAm";
    CompetitorType[CompetitorType["Team"] = 6] = "Team";
    CompetitorType[CompetitorType["Formation"] = 7] = "Formation";
    CompetitorType[CompetitorType["SmallTeam"] = 8] = "SmallTeam";
    CompetitorType[CompetitorType["BigTeam"] = 9] = "BigTeam";
})(CompetitorType || (CompetitorType = {}));
var SeriesType;
(function (SeriesType) {
    SeriesType[SeriesType["Unknown"] = 0] = "Unknown";
    SeriesType[SeriesType["DanceForAll"] = 1] = "DanceForAll";
    SeriesType[SeriesType["Professional"] = 2] = "Professional";
    SeriesType[SeriesType["DanceSport"] = 3] = "DanceSport";
    SeriesType[SeriesType["Caribbean"] = 4] = "Caribbean";
})(SeriesType || (SeriesType = {}));
var CompetitionType;
(function (CompetitionType) {
    CompetitionType[CompetitionType["Unknown"] = 0] = "Unknown";
    CompetitionType[CompetitionType["Cup"] = 1] = "Cup";
    CompetitionType[CompetitionType["Ranking"] = 2] = "Ranking";
    CompetitionType[CompetitionType["League"] = 3] = "League";
    CompetitionType[CompetitionType["Championship"] = 4] = "Championship";
    CompetitionType[CompetitionType["TopLevel"] = 5] = "TopLevel";
    CompetitionType[CompetitionType["SuperLeague"] = 6] = "SuperLeague";
    CompetitionType[CompetitionType["G_Cup"] = 7] = "G_Cup";
})(CompetitionType || (CompetitionType = {}));
var AgeType;
(function (AgeType) {
    AgeType[AgeType["Unknown"] = 0] = "Unknown";
    AgeType[AgeType["Under_8"] = 1] = "Under_8";
    AgeType[AgeType["Juvenile_I"] = 2] = "Juvenile_I";
    AgeType[AgeType["Juvenile_II"] = 3] = "Juvenile_II";
    AgeType[AgeType["Juvenile"] = 4] = "Juvenile";
    AgeType[AgeType["Junior_I"] = 5] = "Junior_I";
    AgeType[AgeType["Junior_II"] = 6] = "Junior_II";
    AgeType[AgeType["Junior"] = 7] = "Junior";
    AgeType[AgeType["Youth"] = 8] = "Youth";
    AgeType[AgeType["Under_21"] = 9] = "Under_21";
    AgeType[AgeType["Adult"] = 10] = "Adult";
    AgeType[AgeType["Senior_I"] = 11] = "Senior_I";
    AgeType[AgeType["Senior_Ia"] = 17] = "Senior_Ia";
    AgeType[AgeType["Senior_Ib"] = 18] = "Senior_Ib";
    AgeType[AgeType["Senior_II"] = 12] = "Senior_II";
    AgeType[AgeType["Senior_III"] = 13] = "Senior_III";
    AgeType[AgeType["Senior_IV"] = 14] = "Senior_IV";
    AgeType[AgeType["Senior_V"] = 15] = "Senior_V";
    AgeType[AgeType["Senior"] = 16] = "Senior";
})(AgeType || (AgeType = {}));
var CompetitionClassType;
(function (CompetitionClassType) {
    CompetitionClassType[CompetitionClassType["Unknown"] = 0] = "Unknown";
    CompetitionClassType[CompetitionClassType["Entry"] = 1] = "Entry";
    CompetitionClassType[CompetitionClassType["E"] = 2] = "E";
    CompetitionClassType[CompetitionClassType["D"] = 3] = "D";
    CompetitionClassType[CompetitionClassType["C"] = 4] = "C";
    CompetitionClassType[CompetitionClassType["B"] = 5] = "B";
    CompetitionClassType[CompetitionClassType["A"] = 6] = "A";
    CompetitionClassType[CompetitionClassType["M"] = 7] = "M";
    CompetitionClassType[CompetitionClassType["Open"] = 8] = "Open";
    CompetitionClassType[CompetitionClassType["Novice"] = 9] = "Novice";
    CompetitionClassType[CompetitionClassType["Bronze"] = 10] = "Bronze";
    CompetitionClassType[CompetitionClassType["Silver"] = 11] = "Silver";
    CompetitionClassType[CompetitionClassType["Gold"] = 12] = "Gold";
})(CompetitionClassType || (CompetitionClassType = {}));
var CompetitionClassTypeItems = [
    CompetitionClassType.Unknown,
    CompetitionClassType.Entry,
    CompetitionClassType.E,
    CompetitionClassType.D,
    CompetitionClassType.C,
    CompetitionClassType.B,
    CompetitionClassType.A,
    CompetitionClassType.M,
    CompetitionClassType.Open,
    CompetitionClassType.Novice,
    CompetitionClassType.Bronze,
    CompetitionClassType.Silver,
    CompetitionClassType.Gold,
];
export var getAvailableCompetitionClassTypeValues = function (series) {
    if (series === SeriesType.DanceSport) {
        return [
            CompetitionClassType.M,
            CompetitionClassType.A,
            CompetitionClassType.B,
            CompetitionClassType.C,
            CompetitionClassType.D,
            CompetitionClassType.E,
        ];
    }
    if (series === SeriesType.DanceForAll) {
        return [
            CompetitionClassType.Gold,
            CompetitionClassType.Silver,
            CompetitionClassType.Bronze,
            CompetitionClassType.Novice,
        ];
    }
    if (series === SeriesType.Professional) {
        return [
            CompetitionClassType.Open,
        ];
    }
    return [];
};
var DisciplineType;
(function (DisciplineType) {
    DisciplineType[DisciplineType["Unknown"] = 0] = "Unknown";
    DisciplineType[DisciplineType["Standard"] = 1] = "Standard";
    DisciplineType[DisciplineType["Latin"] = 2] = "Latin";
    DisciplineType[DisciplineType["Standard_Latin"] = 3] = "Standard_Latin";
    DisciplineType[DisciplineType["Breaking"] = 4] = "Breaking";
    DisciplineType[DisciplineType["SingleDance"] = 5] = "SingleDance";
    DisciplineType[DisciplineType["FreeStyle"] = 6] = "FreeStyle";
    DisciplineType[DisciplineType["Other"] = 7] = "Other";
    DisciplineType[DisciplineType["ShowdanceStandard"] = 8] = "ShowdanceStandard";
    DisciplineType[DisciplineType["ShowdanceLatin"] = 9] = "ShowdanceLatin";
    DisciplineType[DisciplineType["TenDance"] = 10] = "TenDance";
    DisciplineType[DisciplineType["Bachata"] = 11] = "Bachata";
    DisciplineType[DisciplineType["Merengue"] = 12] = "Merengue";
    DisciplineType[DisciplineType["Salsa"] = 13] = "Salsa";
    DisciplineType[DisciplineType["ShowdanceBachata"] = 14] = "ShowdanceBachata";
    DisciplineType[DisciplineType["ShowdanceMerengue"] = 15] = "ShowdanceMerengue";
    DisciplineType[DisciplineType["ShowdanceSalsa"] = 16] = "ShowdanceSalsa";
    DisciplineType[DisciplineType["Caribbean"] = 17] = "Caribbean";
})(DisciplineType || (DisciplineType = {}));
var EventType;
(function (EventType) {
    EventType[EventType["Competition"] = 0] = "Competition";
})(EventType || (EventType = {}));
var EventState;
(function (EventState) {
    EventState[EventState["Private"] = 0] = "Private";
    EventState[EventState["Waiting"] = 1] = "Waiting";
    EventState[EventState["Approved"] = 2] = "Approved";
    EventState[EventState["Public"] = 3] = "Public";
    EventState[EventState["Cancelled"] = 100] = "Cancelled";
    EventState[EventState["Checked"] = 900] = "Checked";
})(EventState || (EventState = {}));
export var eventStateValues = [
    EventState.Private,
    EventState.Waiting,
    EventState.Approved,
    EventState.Public,
    EventState.Cancelled,
];
export { AgeType, DisciplineType, EventType, EventState, RegistrationState, EventOfficialDefaults, OfficialRole, CompetitionClassType, CompetitionClassTypeItems, CompetitionDefaults, CompetitionType, CompetitorType, StartType, SeriesType, };
